<template>
  <div>
    <b-container>
      <h1 class="text-center">Richmond, VA, Crawlspaces &amp; Basements</h1>
      <hr>
      <p>Cut down on excessive moisture with crawlspace drainage or a basement subfloor system. Research and usage has shown that closing the crawlspace so that the crawlspace has no ventilation to the outside can provide greatly improved moisture control and results in significant energy savings when installed properly. We also install sump pumps, dehumidifiers, insulation, and vapor barriers. We are licensed to repair all structural damage from moisture, mold, and termites, as well as preform termite treatments.</p>
      <b-row>
        <b-col>
          <b-carousel controls indicators :interval=interval>
            <b-carousel-slide img-src="/slide1.jpg"/>
            <b-carousel-slide img-src="/slide1.jpg"/>
            <b-carousel-slide img-src="/slide1.jpg"/>
            <b-carousel-slide img-src="/slide1.jpg"/>
            <b-carousel-slide img-src="/slide1.jpg"/>
            <b-carousel-slide img-src="/slide1.jpg"/>
          </b-carousel>
        </b-col>
        <b-col>
          <h2>Taking Care of Your Crawlspace</h2>
          <p>Do you know what's in your crawlspace? You might have problems with moisture, mold, or even structural damage. Some of the common symptoms of excessive crawlspace moisture are:</p>
          <ul>
            <li>Mold or Moisture Damage in the Crawlspace or Living Area</li>
            <li>Musty Odors in the Living Area</li>
            <li>Condensation (Sweating) on Air Conditioning Duct Work or Equipment</li>
            <li>High Humidity in the Crawlspace &amp; Living Area</li>
            <li>Mold Growth on Surfaces</li>
            <li>Condensation on Insulation, Water Pipes, or Rusty Metal in Crawlspace</li>
            <li>Buckling Hardwood Floors</li>
            <li>Doors &amp; Windows That Stick Due to Swelling</li>
            <li>Insect Infestations by Termites &amp; Wood-Boring Beetles</li>
            <li>Mold Leading to Rot in Wooden Framing Members</li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      interval: 5000,
    }
  }
}
</script>

<style>

</style>
